import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
export const queryServiceByFormId = async _ref => {
  let {
    httpClient,
    formId
  } = _ref;
  try {
    var _await$httpClient$req;
    return (_await$httpClient$req = (await httpClient.request(queryServices({
      query: {
        filter: {
          'form.id': {
            $in: [formId]
          }
        }
      }
    }))).data.services) == null ? void 0 : _await$httpClient$req[0];
  } catch (e) {
    console.error('Failed to query service by form id', e);
    return undefined;
  }
};
//# sourceMappingURL=query-service-by-form-id.js.map